import { RIGHTBAR_DEFAULT_WIDTH, RIGHTBAR_ROLES_WIDTH } from "@ryde/shared";

export const normalizeSearchText = (value: string): string => {
  return (value ?? "")
    .toLowerCase()
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_\-.]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
};

export const normalizeSearchTextFlat = (value: string): string =>
  normalizeSearchText(value).replace(/\s/g, "");

export const getDrawerWidthByEntity = (entity: string): string => {
  switch (entity) {
    case "role":
      return RIGHTBAR_ROLES_WIDTH;
    default:
      return RIGHTBAR_DEFAULT_WIDTH;
  }
};
